import React, { useContext } from "react";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { checkRole } from "../../util/FormUtils";
import BoxFileManager from "./BoxFileManager";
import { UserContext } from "../../context/UserContext";
import ROLES from "../../util/roles";
import xplanLabels from "../../util/XplanLabels";

const Approval = ({ handleApproved, approvalComment, approvalFolderId, handleChange }) => {
    const { user } = useContext(UserContext);

    return (
        <>
            {checkRole(user, [ROLES.APPROVER]) && (
                <div id="approval">
                    <Paper variant="outlined" className="planWarning planApprovalContainer fullLength">
                        <Box style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "0",
                        }}>
                            <Typography>Experimental Plan Approval</Typography>
                            <div className="planApprovalButtons">
                                <Button
                                    onClick={handleApproved}
                                    className="planApprovalButton"
                                    startIcon={<ThumbUpAltIcon />}
                                >
                                    APPROVE
                                </Button>
                            </div>
                        </Box>
                        <TextField
                            name="approvalComment"
                            label={xplanLabels.approvalComment}
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            value={approvalComment ? approvalComment : ""}
                            onChange={(e) => handleChange("approvalComment", e.target.value)}
                            multiline
                            minRows={1}
                            className="fullLength"
                        />
                        <BoxFileManager
                            folderId={approvalFolderId}
                            title={`Approval Files`}
                            allowedRoles={[ROLES.APPROVER]}
                        />
                    </Paper>
                </div>
            )}
        </>
    );
};

export default Approval;
